import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { DocsComponent, Tasklist } from "./Table";

const Employeeworkspace = () => {
  const [activeTab, setActiveTab] = useState("List");

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };
  const propertyobject = JSON.parse(sessionStorage.getItem("property"));
  return (
    <>
      <div className="mt-4">
        <div className="row mx-0 ">
          <h5 className="col m-0 p-0"> {propertyobject.workspace_name}</h5>
          <div className="col d-flex justify-content-end">
            <Link to="/Employee/work-dashboard" style={{}}>
              Back
            </Link>
          </div>
        </div>
      </div>
      <hr className="m-1" />
      <div className="w-100  ">{activeTab === "List" && <Tasklist />}</div>
    </>
  );
};

export default Employeeworkspace;
